import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PublisherResource, publishersSearch } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const usePublisherSearch = (
  query?: string,
  expand?: string[],
  filter?: string[],
  sort?: string[],
  page?: number,
  perPage?: number,
  options: Omit<UseQueryOptions<PublisherResource[], unknown>, 'queryKey'> = {}
) =>
  useQuery({
    queryFn: () =>
      extractData(
        publishersSearch({
          query: { q: query, expand, filter, sort, page, perPage },
        })
      ),
    queryKey: [
      'publishers',
      'search',
      { query, expand, filter, sort, page, perPage },
    ],
    ...options,
  });
